<footer class="footer js-footer">
  <div class="footer-container">
    <svg-icon
      src="assets/images/footer-logo.svg"
      [svgStyle]="{ fill: 'var(--NestBuilder-Neutrals-Cream)' }"
      class="pointer"
      routerLink="{{ RoutePaths.HOME }}"></svg-icon>
    <app-typography
      variant="body-large"
      class="rights text-center"
      color="var(--NestBuilder-Neutrals-Cream)"
      >&copy; 2025 All rights reserved</app-typography
    >
    <div class="footer-links">
      @for (link of links; track link.name) {
        <a class="footer-link" [routerLink]="link.route">{{ link.name }}</a>
      }
    </div>
  </div>
</footer>
